import React from 'react'
import {
  KpiCardWrapper,
  KpiIcon,
  KpiContent,
  KpiValue,
  KpiLabel,
  KpiSublabel,
  KpiTrend,
} from '../HrAnalytics.styled'

interface IKpiCard {
  icon?: React.ReactNode
  value: string | number
  label: string
  sublabel?: string
  trend?: {
    value: string
    positive: boolean
  }
  accentColor?: string
  iconColor?: string
}

export const KpiCard = ({
  icon,
  value,
  label,
  sublabel,
  trend,
  accentColor,
  iconColor,
}: IKpiCard) => {
  return (
    <KpiCardWrapper accentColor={accentColor}>
      {icon && <KpiIcon color={iconColor || accentColor}>{icon}</KpiIcon>}
      <KpiContent>
        <KpiValue>{value}</KpiValue>
        <KpiLabel>{label}</KpiLabel>
        {sublabel && <KpiSublabel>{sublabel}</KpiSublabel>}
      </KpiContent>
      {trend && (
        <KpiTrend positive={trend.positive}>
          {trend.positive ? '▲' : '▼'} {trend.value}
        </KpiTrend>
      )}
    </KpiCardWrapper>
  )
}
